import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { despesasDeViagensAdiantamentoFinListAction, despesasDeViagensAdiantamentoFinAprovaAction } from '../../actions/DespesasDeViagensActions';
import {
    Tab, Table, Button, Icon, Popup
} from 'semantic-ui-react';

const StyledTable = styled(Table)`
  &&& {
    border-spacing: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 0px 0px;
   }    
`;

const StyledTableHeader = styled(Table.Header)`
&&& th {
    padding: 0px;
    margin: 0px 0px 0px 0px;
}
`;

const StyledTableBody = styled(Table.Body)`
&&& 
 td{
    padding: 2px 2px !important;
    margin: 0px 0px 0px 0px !important;
}
`;


function AdiantamentoFin(props) {

    const { adiantamentoFinList, isLoadingAdiantamentoFinList, userid, listAcomuladoFin } = props; // Reducers
    const { despesasDeViagensAdiantamentoFinListAction, despesasDeViagensAdiantamentoFinAprovaAction } = props; // actions


    const [loadingAprovado, setLoadingAprovado] = useState(true);
    const [loadingNegado, setLoadingNegado] = useState(true);
    const [listaOrdenada, setListaOrdenada] = useState([]);
    const [ordemAlfabeticaAsc, setOrdemAlfabeticaAsc] = useState(true);

    useEffect(() => {
        despesasDeViagensAdiantamentoFinListAction().then((data) => {
            setListaOrdenada([...listAcomuladoFin]);
            setLoadingAprovado(false);
            setLoadingNegado(false);
        })
    }, []);

    useEffect(() => {
        setListaOrdenada([...listAcomuladoFin]);
    }, [listAcomuladoFin]);


    const handleClick = (status, id) => {
        let data = {
            status: status == 'Aprovado' ? 1 : 2,
            idviagem: parseInt(id),
            userid: parseInt(userid),
            alloc: 'N'
        }
        despesasDeViagensAdiantamentoFinAprovaAction(data).then((data) => {

            despesasDeViagensAdiantamentoFinListAction()
            setLoadingAprovado(false);
            setLoadingNegado(false);
        })

        if (status === 'Aprovado') {
            setLoadingAprovado(true);
        } else if (status === 'Negado') {
            setLoadingNegado(true);
        }
    }

    const handleAproveAll = () => {
        const ids = listaOrdenada.map(item => parseInt(item.id));
        const data = {
            status: 1, // 1 = Aprovado
            idviagem: ids,
            userid: parseInt(userid),
            alloc: 'S'
        };

        console.log(data)
        setLoadingAprovado(true);

        despesasDeViagensAdiantamentoFinAprovaAction(data).then(() => {
            despesasDeViagensAdiantamentoFinListAction();
            setLoadingAprovado(false);
        });
    }

    const ordenarPorNome = () => {
        const novaLista = [...listaOrdenada].sort((a, b) => {
            const nomeA = a.motorista.toLowerCase();
            const nomeB = b.motorista.toLowerCase();
            if (nomeA < nomeB) return ordemAlfabeticaAsc ? -1 : 1;
            if (nomeA > nomeB) return ordemAlfabeticaAsc ? 1 : -1;
            return 0;
        });
        setListaOrdenada(novaLista);
        setOrdemAlfabeticaAsc(!ordemAlfabeticaAsc);
    };

    return (
        <>
            <div style={{ margin: '10px 5px 10px 5px', width: '100%', display: 'flex ', justifyContent: 'flex-end' }}>
                <Button
                    color='green'
                    icon={'gavel'}
                    onClick={() => handleAproveAll()}
                    disabled={loadingAprovado}
                >Aprovar todos</Button >
            </div>
            <Tab.Pane loading={isLoadingAdiantamentoFinList}>
                <div>
                    <StyledTable>
                        <StyledTableHeader>
                            <Table.Row style={{}}>
                                <Table.HeaderCell>OC</Table.HeaderCell>
                                <Table.HeaderCell>
                                    Nome do Motorista
                                    <Icon
                                        name={listaOrdenada ? 'sort alphabet down' : 'sort alphabet up'}
                                        style={{ marginLeft: '5px', cursor: 'pointer' }}
                                        onClick={ordenarPorNome}
                                    />
                                </Table.HeaderCell>
                                <Table.HeaderCell>Valor</Table.HeaderCell>
                                <Table.HeaderCell>Data da Solicitação</Table.HeaderCell>
                                <Table.HeaderCell>Saldo Devedor</Table.HeaderCell>
                                <Table.HeaderCell>Status</Table.HeaderCell>
                            </Table.Row>
                        </StyledTableHeader>
                        {listaOrdenada.map((item) => (
                            <StyledTableBody >
                                <Table.Cell>{item.oc}</Table.Cell>
                                <Popup
                                    trigger={<Table.Cell>{item.motorista} ( {item.codparc} )</Table.Cell>}
                                    flowing
                                    hoverable
                                    on={["hover", "click"]}
                                >
                                    <p>Motorista: <b>{item.motorista}</b></p>
                                    <table border='1px' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}><b>OC</b></th>
                                                <th style={{ padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}>NATUREZA</th>
                                                <th style={{ padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}>CIDADE</th>
                                                <th style={{ padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}>ROTA</th>
                                                <th style={{ padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}>VALOR</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {adiantamentoFinList.filter(adiantamento => adiantamento.oc === item.oc).map(itempopup => (
                                                <tr key={itempopup.ordemcarga}>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{itempopup.oc}</td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{itempopup.despesa}</td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{itempopup.cidade}</td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{itempopup.rota}</td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(itempopup.valor)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tr key={item.valorTotal}>
                                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }} colSpan={4} align='right'><b>Total:</b></td>
                                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.valorTotal)}</td>
                                        </tr>
                                    </table>
                                </Popup>
                                <Table.Cell>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.valorTotal)}</Table.Cell>
                                <Table.Cell> {new Date(item.dtSolicitacao).toLocaleDateString('pt-BR', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                })}</Table.Cell>
                                <Table.Cell>
                                    {item.saldo_devedor > 0 ? (
                                        <div style={{ color: 'red' }}>
                                            -({new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(item.saldo_devedor))})
                                        </div>
                                    ) : (
                                        <div>
                                            0,00
                                        </div>
                                    )}
                                </Table.Cell>
                                <Table.Cell>
                                    <Button icon={'gavel'} color={'green'} size="mini" loading={loadingAprovado} disabled={loadingAprovado || loadingNegado} onClick={() => handleClick('Aprovado', item.id)}></Button>
                                    <Button icon={'trash alternate outline'} color={'red'} size="mini" loading={loadingNegado} disabled={loadingNegado || loadingAprovado} onClick={() => handleClick('Negado', item.id)}></Button>
                                </Table.Cell>
                            </StyledTableBody>
                        ))}
                    </StyledTable>
                </div>
            </Tab.Pane>
        </>
    );
}


const mapStateToProps = (state) => ({
    adiantamentoFinList: state.DespesasDeViagensReducer.adiantamentoFinList,
    isLoadingAdiantamentoFinList: state.DespesasDeViagensReducer.isLoadingAdiantamentoFinList,
    userid: state.LoginReducer.userid,
    listAcomuladoFin: state.DespesasDeViagensReducer.listAcomuladoFin,
});

export default withRouter(connect(mapStateToProps, {
    despesasDeViagensAdiantamentoFinListAction,
    despesasDeViagensAdiantamentoFinAprovaAction
})(AdiantamentoFin));
